import classNames from 'classnames'
import { oneOf, string } from 'prop-types'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import {
  PAGE_TYPE_CATEGORY,
  PAGE_TYPE_SEARCH_RESULTS,
  PAGE_TYPES,
} from 'shared/consts/page'
import FilterBoxVariant from 'shared/experiments/components/NewSerp/FilterBox'
import InfiniteHits from 'shared/experiments/components/SerpLoadMore/InfiniteHits'
import SerpNowPushWidget from 'shared/experiments/components/SerpNowPush/SerpNowPushWidget'
import {
  EXPERIMENT_VARIATION,
  NOW_PDP_SERP_GB_FUNCTIONALITY,
  SERP_LOAD_MORE,
  SERP_NOW_PUSH,
} from 'shared/experiments/consts'
import logger from 'shared/services/logger'
import NowNotAvailableBox from 'views/components/molecules/NowNotAvailableBox'
import FilterBox from 'views/components/organisms/AlgoliaInstantSearch/Algolia/FilterBox'
import RegularHits from 'views/components/organisms/AlgoliaInstantSearch/Algolia/Hits'
import Pagination from 'views/components/organisms/AlgoliaInstantSearch/Algolia/Pagination'
import { shouldBeShippedToday } from 'views/components/organisms/NowCountdown/helpers'
import Experiment from 'views/components/utils/optimizely/Experiment'
import buildClientAPI from 'views/providers/clientAPI'

const ProductFilterHits = ({
  query,
  indexName,
  className,
  pageType,
  noveltiesIndexName,
}) => {
  const nowData = useSelector(state => state.nowData)
  const [nowEligible, setNowEligible] = useState(true)

  useEffect(() => {
    const handleZipChange = async () => {
      try {
        if (nowData?.zipCode) {
          const { nowService } = buildClientAPI()

          const response = await nowService.fetchBasicData({
            zipCode: nowData?.zipCode,
          })
          setNowEligible(response.zipCodeInDeliveryRegion)
        }
      } catch (error) {
        logger.error(error)
      }
    }

    void handleZipChange()
  }, [nowData?.zipCode])

  const isSearchPage = pageType === PAGE_TYPE_SEARCH_RESULTS
  const shouldRenderLoadMoreExperiment = exp =>
    isSearchPage && exp.variant !== EXPERIMENT_VARIATION.DEFAULT
  const shouldRenderNowPushWidgetExperiment =
    isSearchPage && shouldBeShippedToday()

  return (
    <>
      <div className={classNames(className, 'u-margin--bottom')}>
        {isSearchPage ? (
          <FilterBoxVariant indexName={indexName} />
        ) : (
          <FilterBox
            indexName={indexName}
            noveltiesIndexName={noveltiesIndexName}
          />
        )}
        <Experiment name={NOW_PDP_SERP_GB_FUNCTIONALITY}>
          {({ isEnabled, variant }) =>
            isEnabled &&
            pageType !== PAGE_TYPE_CATEGORY &&
            [EXPERIMENT_VARIATION.V1, EXPERIMENT_VARIATION.V2].includes(
              variant
            ) && (
              <div hidden={nowEligible}>
                <NowNotAvailableBox />
              </div>
            )
          }
        </Experiment>
        {shouldRenderNowPushWidgetExperiment && (
          <Experiment name={SERP_NOW_PUSH}>
            {experiment =>
              experiment.variant === EXPERIMENT_VARIATION.V2 && (
                <SerpNowPushWidget />
              )
            }
          </Experiment>
        )}
        <Experiment name={SERP_LOAD_MORE}>
          {experiment =>
            shouldRenderLoadMoreExperiment(experiment) ? (
              <InfiniteHits query={query} />
            ) : (
              <RegularHits query={query} />
            )
          }
        </Experiment>
      </div>
      <Experiment name={SERP_LOAD_MORE}>
        {experiment =>
          shouldRenderLoadMoreExperiment(experiment) ? null : (
            <Pagination scrollToTopAfterClick />
          )
        }
      </Experiment>
    </>
  )
}

ProductFilterHits.propTypes = {
  indexName: string.isRequired,
  pageType: oneOf(PAGE_TYPES).isRequired,
  query: string,
  className: string,
  noveltiesIndexName: string,
}

ProductFilterHits.defaultProps = {
  query: null,
  className: null,
  noveltiesIndexName: null,
}

export default ProductFilterHits
